import { EquipeSelectModel, UnidadeSaudeSelectModel } from 'components/form'
import { LoadImoveisInativacaoQuery } from 'graphql/types.generated'

export const MAXIMUM_INATIVACAO_IMOVEIS_SIZE = 30

export interface InativacaoImoveisBuscaFormModel {
  logradouro?: string
  cep?: string
  unidadeSaude?: UnidadeSaudeSelectModel
  equipe?: EquipeSelectModel
  microarea?: string
  ocultarImoveisComFamilia?: boolean
}

export type InativacaoImoveisQueryResult = LoadImoveisInativacaoQuery['imoveis']
export type InativacaoImovelItemModel = LoadImoveisInativacaoQuery['imoveis']['content'][0]
export interface InativacaoImovelActionModel {
  id: InativacaoImovelItemModel['id']
  familias: InativacaoImovelItemModel['familias']
  permissaoReterritorializar?: InativacaoImovelItemModel['permissaoReterritorializar']
}

export interface CheckAllActionParams {
  disabled?: boolean
  checkAllChecked: boolean
  checkedItemsSize: number
  validImoveisUncheckedSize: number
}

export interface ItemActionParams {
  disabled?: boolean
  checkedItems: Set<string>
  item: InativacaoImovelItemModel
}
